export const isPromise = <T>(
  subject: T | Promise<T>
): subject is Promise<T> => {
  if (subject && typeof subject === `object`) {
    return typeof (subject as { then: unknown }).then === `function`
  }

  return false
}
